import React, { useEffect } from 'react';
import { Typography, Card, Divider } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const Terms = ({ analytics }) => {
    const { i18n } = useTranslation();
    const isRu = i18n.language === 'ru';

    useEffect(() => {
        analytics();
    }, [analytics]);

    return (
        <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
            <Card style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <Title level={2} style={{ textAlign: 'center' }}>
                    {isRu ? 'Условия использования' : 'Օգտագործման պայմաններ'}
                </Title>
                <Divider />
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                    {isRu
                        ? 'Пользуясь сайтом AvtoDas, вы соглашаетесь с нижеперечисленными условиями.'
                        : 'Օգտվելով AvtoDas կայքից, դուք համաձայնում եք ստորև նշված պայմաններին։'
                    }
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                    {isRu
                        ? 'Материалы, представленные на сайте, предназначены исключительно для информационных и образовательных целей. Мы делаем всё возможное для обеспечения точности информации, однако не несем ответственности за возможные неточности.'
                        : 'Կայքում ներկայացված նյութերը նախատեսված են միայն տեղեկատվական և կրթական նպատակների համար։ Մենք ամեն ինչ անում ենք տեղեկատվության ճշգրտությունն ապահովելու համար, սակայն պատասխանատվություն չենք կրում հնարավոր անճշտությունների համար։'
                    }
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                    {isRu
                        ? 'В случае вопросов пишите нам по адресу info@avtodas.am.'
                        : 'Հարցերի դեպքում գրեք մեզ info@avtodas.am հասցեով։'
                    }
                </Paragraph>
            </Card>
        </div>
    );
};

export default Terms;
